module Meevo.Components.LocationPicker {
    angular.module("meevo.components.locationPicker", []);
}